import React from 'react';
import { Box } from '@mui/material';

const ErrorPage = () => {
  return(<Box sx={{
    paddingTop: '50vh'
  }}>
    404 error... page not found.
  </Box>);
};

export default ErrorPage;